/* global globalThis */
import { markRaw } from "vue";
import { fetchEvent, fetchQueueState, fetchQueueRevision } from "@/lib/api";
import { createEventSocket } from "@/lib/eventSocket";
import { createQueueSync } from "@/lib/queueSync";
import QueueSyncStatus from "@/components/Management/QueueSyncStatus.vue";

function uniqueId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export default {
  components: { QueueSyncStatus },
  data() {
    return { queueSync: null, syncState: { status: "SYNCING", lastAppliedRevision: -1, reason: "Checking ceremony state." } };
  },
  computed: {
    canOperate() { return this.syncState.status === "LIVE" && !this.syncState.pending; },
  },
  watch: {
    eventId() {
      this.queueSync?.stop();
      this.snapshot = null;
      if ("lastQueueRevision" in this) this.lastQueueRevision = -1;
      this.error = "";
      this.startQueueSync();
    },
  },
  methods: {
    startQueueSync() {
      this.queueSync?.stop();
      const eventId = this.eventId;
      this.queueSync = markRaw(createQueueSync({
        eventId,
        deviceId: uniqueId(), // Per-view session identity, untrusted audit metadata.
        operationId: uniqueId,
        fetchSnapshot: () => fetchEvent(eventId),
        fetchQueue: () => fetchQueueState(eventId),
        fetchRevision: () => fetchQueueRevision(eventId),
        openSocket: (handlers) => createEventSocket(eventId, handlers),
        onSnapshot: (snapshot) => this.applySnapshot(snapshot, { includeViews: true }),
        onStatus: (state) => { this.syncState = state; },
      }));
      this.queueSync.start();
    },
    async runQueueOperation(send, payload = {}) {
      try {
        this.error = "";
        return await this.queueSync.runOperation(send, payload);
      } catch (error) {
        if (this.syncState.pending) return null; // The sync banner owns an unconfirmed action.
        this.error = error?.response?.status === 409
          ? "Another device changed the queue. Review the updated position and try your action again."
          : error?.response?.data?.error || error.message || "Unable to confirm this action.";
        return null;
      }
    },
  },
  beforeUnmount() { this.queueSync?.stop(); },
};
